import React from "react";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import SearchBar from "../../ui/SearchBar";

interface VehicleTableControlsProps {
  sortBy: "time" | "alphabetical";
  onSortChange: (value: "time" | "alphabetical") => void;
  searchTerm: string;
  onSearchChange: (value: string) => void;
}

const VehicleTableControls: React.FC<VehicleTableControlsProps> = ({
  sortBy,
  onSortChange,
  searchTerm,
  onSearchChange,
}) => {
  return (
    <Box
      sx={{
        mb: 2,
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 2,
        }}
      >
        <FormControl size="small" sx={{ minWidth: 150 }}>
          <InputLabel sx={{ fontFamily: "SigmaSans" }}>Sort by</InputLabel>
          <Select
            value={sortBy}
            label="Sort by"
            onChange={(e) =>
              onSortChange(e.target.value as "time" | "alphabetical")
            }
            sx={{ fontFamily: "SigmaSans" }}
          >
            <MenuItem value="time" sx={{ fontFamily: "SigmaSans" }}>
              Newest - Oldest
            </MenuItem>
            <MenuItem value="alphabetical" sx={{ fontFamily: "SigmaSans" }}>
              Alphabetical: A - Z
            </MenuItem>
          </Select>
        </FormControl>
        <SearchBar
          value={searchTerm}
          onChange={onSearchChange}
          placeholder="Search license plates..."
        />
      </Box>
    </Box>
  );
};

export default VehicleTableControls;
